module.exports = __webpack_public_path__ + "media/images/riders/LAURIE_GREENLAND-82856aeace34834d3bb9a01e0f085528.png";